import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import {
  CheckboxComponent,
  CheckboxGroupComponent,
  ControlComponent,
  CustomControlsModule,
  DateFormatPipe,
  DownloadFileComponent,
  ErrorValidationComponent,
  FileUploadComponent,
  LabelInfoComponent,
  PartnerhubModule,
  PriceModelComponent,
  RadioGroupComponent,
  SelectInputComponent,
  StepperComponent,
  StepperModule,
  StepperOfferComponent,
  ToggleColumnDirective,
  ToggleTableDirective,
} from 'partnerhub';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { ChipsModule } from 'primeng/chips';
import { NgxPowerBiModule } from 'ngx-powerbi';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { DocumentsComponent } from './../document/components/documents/documents.component';
import { BootstrapModule } from './bootstrap/bootstrap.module';
import { BundlesExceptionComponent } from './components/bundles/bundles-exception/bundles-exception.component';
import { CanDeactivateComponent } from './components/can-deactivate/can-deactivate.component';
import { CardComponent } from './components/card/card.component';
import { MapListComponent } from './components/map-list/map-list.component';
import { PaymentDiagramComponent } from './components/mocks-to-erase/payment-diagram/payment-diagram.component';
import { ReconciliationDiagramComponent } from './components/mocks-to-erase/reconciliation-diagram/reconciliation-diagram.component';
import { SettlementDateBoxComponent } from './components/mocks-to-erase/settlement-date-box/settlement-date-box.component';
import { TransactionDetailsTableComponent } from './components/mocks-to-erase/transaction-details-table/transaction-details-table.component';
import { ModalXlComponent } from './components/modal-xl/modal-xl.component';
import { ModalComponent } from './components/modal/modal.component';
import { NoResultsFoundComponent } from './components/no-results-found/no-results-found.component';
import { CompanyInformationComponent } from './components/onboarding/company-information/company-information.component';
import { ContactInformationComponent } from './components/onboarding/contact-information/contact-information.component';
import { OthersComponent } from './components/onboarding/others/others.component';
import { SupplierDocumentationComponent } from './components/onboarding/supplier-documentation/supplier-documentation.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PartnerDependenciesComponent } from './components/partner/partner-dependencies/partner-dependencies.component';
import { PartnerDependencyCommunicationComponent } from './components/partner/partner-dependency-communication/partner-dependency-communication.component';
import { PartnerDocumentationComponent } from './components/partner/partner-documentation/partner-documentation.component';
import { PresentationComponent } from './components/presentation/presentation.component';
import { PreviewImageComponent } from './components/preview-image/preview-image.component';
import { CampaingProductComponent } from './components/products/campaing-product/campaing-product.component';
import { CostModelComponent } from './components/products/cost-model/cost-model.component';
import { CountryOperatorComponent } from './components/products/country-operator/country-operator.component';
import { OfferCommunicationComponent } from './components/products/offer-communication/offer-communication.component';
import { OfferDetailsComponent } from './components/products/offer-details/offer-details.component';
import { OfferDocumentsComponent } from './components/products/offer-documents/offer-documents.component';
import { OfferComponent } from './components/products/offer/offer.component';
import { OffersComponent } from './components/products/offers/offers.component';
import { ProductDependenciesComponent } from './components/products/product-dependencies/product-dependencies.component';
import { ProductDetailsComponent } from './components/products/product-details/product-details.component';
// import { TabProductsComponent } from './components/products/tab-products/tab-products.component';
import { ViewOfferDetailsComponent } from './components/products/view-offer-details/view-offer-details.component';
import { ViewOfferStateComponent } from './components/products/view-offer-state/view-offer-state.component';
import { ViewProductComponent } from './components/products/view-product/view-product.component';
import { TabMenuComponent } from './components/tab-menu/tab-menu.component';
import { TableSearchComponent } from './components/table-search/table-search.component';
import { OfferCampaignsComponent } from './components/products/offer-campaigns/offer-campaigns.component';
import { OfferNotificationsComponent } from './components/products/offer-notifications/offer-notifications.component';
import { OfferLoyaltyComponent } from './components/products/offer-loyalty/offer-loyalty.component';
import { OfferLoyaltyEditComponent } from './components/products/offer-loyalty-edit/offer-loyalty-edit.component';
import { OfferTributesComponent } from './components/products/offer-tributes/offer-tributes.component';
import { OfferTributesEditComponent } from './components/products/offer-tributes-edit/offer-tributes-edit.component';

import { CampaignDetailsComponent } from './components/products/campaign-details/campaign-details.component';
import { MapListConditionPipe } from './pipes/map-list/map-list-condition.pipe';
import { BaseTableComponent } from './components/base-table/base-table.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { FormBuilderComponent } from '../shared/components/form-builder/form-builder.component';
import { CampaignDetailsComponentEdit } from './components/products/campaign-details-edit/campaign-details-edit.component';
import { FieldFormatterPipe } from './pipes/field-formatter.pipe';
import { LottieModule } from 'ngx-lottie';
import { OfferLoyaltyAddComponent } from './components/products/offer-loyalty-add/offer-loyalty-add.component';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { OfferChargeCodesComponent } from './components/products/offer-charge-codes/offer-charge-codes.component';
import { OfferSkuAddComponent } from './components/products/offer-sku-add/offer-sku-add.component';

export function playerFactory() {
  return import('lottie-web');
}

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.keycloakUrl,
        realm: 'vivo-realm',
        clientId: 'vivo-client'
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/assets/keycloak/silent-check-sso.html'
      },
      loadUserProfileAtStartUp: true
    });
}


@NgModule({
  declarations: [
    // TODO: REmoveu unused component
    PreviewImageComponent,
    ProductDetailsComponent,
    CountryOperatorComponent,
    OfferComponent,
    ViewProductComponent,
    OfferDetailsComponent,
    OfferCommunicationComponent,
    CostModelComponent,
    CompanyInformationComponent,
    ContactInformationComponent,
    PartnerDependenciesComponent,
    PartnerDependencyCommunicationComponent,
    PartnerDocumentationComponent,
    ProductDependenciesComponent,
    BundlesExceptionComponent,
    DocumentsComponent,
    CampaingProductComponent,
    OfferDocumentsComponent,
    SettlementDateBoxComponent,
    ReconciliationDiagramComponent,
    TransactionDetailsTableComponent,
    PaymentDiagramComponent,
    PaginationComponent,
    CanDeactivateComponent,
    ModalComponent,
    CardComponent,
    ModalXlComponent,
    MapListComponent,
    // TODO: REmoveu unused component
    NoResultsFoundComponent,
    SupplierDocumentationComponent,
    OthersComponent,
    PresentationComponent,
    TabMenuComponent,
    TableSearchComponent,
    ViewOfferDetailsComponent,
    ViewOfferStateComponent,
    OffersComponent,
    // TabProductsComponent,
    OfferCampaignsComponent,
    OfferNotificationsComponent,
    OfferTributesComponent,
    OfferTributesEditComponent,
    OfferLoyaltyEditComponent,
    OfferLoyaltyComponent,
    CampaignDetailsComponent,
    MapListConditionPipe,
    BaseTableComponent,
    PageTitleComponent,
    FormBuilderComponent,
    FieldFormatterPipe, 
    CampaignDetailsComponentEdit, 
    OfferLoyaltyAddComponent, 
    OfferChargeCodesComponent,
    OfferSkuAddComponent
  ],
  providers: [
    ConfirmationService,
    KeycloakService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },
  ],
  imports: [
    LottieModule.forRoot({ player: playerFactory }),
    CommonModule,
    BootstrapModule,
    ReactiveFormsModule,
    FormsModule,
    PartnerhubModule,
    CustomControlsModule,
    StepperModule,
    ChartsModule,
    TableModule,
    MessageModule,
    DropdownModule,
    ConfirmDialogModule,
    MultiSelectModule,
    FileUploadModule,
    TreeTableModule,
    ChipsModule,
    DynamicDialogModule,
    DialogModule,
    TabViewModule,
    TabMenuModule,
    TooltipModule,
    RadioButtonModule,
    NgxPowerBiModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    TranslateModule.forChild(),
  ],
  exports: [
    LottieModule,
    CommonModule,
    BootstrapModule,
    ReactiveFormsModule,
    NgxPowerBiModule,
    FormsModule,
    ControlComponent,
    FileUploadComponent,
    SelectInputComponent,
    DownloadFileComponent,
    PreviewImageComponent,
    ProductDetailsComponent,
    CountryOperatorComponent,
    ViewProductComponent,
    OfferComponent,
    OfferDetailsComponent,
    PriceModelComponent,
    CheckboxGroupComponent,
    OfferCommunicationComponent,
    CostModelComponent,
    RadioGroupComponent,
    LabelInfoComponent,
    CompanyInformationComponent,
    ContactInformationComponent,
    PartnerDependenciesComponent,
    PartnerDependencyCommunicationComponent,
    PartnerDocumentationComponent,
    ChartsModule,
    TableModule,
    ProductDependenciesComponent,
    BundlesExceptionComponent,
    DocumentsComponent,
    CampaingProductComponent,
    OfferDocumentsComponent,
    SettlementDateBoxComponent,
    ReconciliationDiagramComponent,
    TransactionDetailsTableComponent,
    PaymentDiagramComponent,
    TranslateModule,
    PaginationComponent,
    CanDeactivateComponent,
    SupplierDocumentationComponent,
    OthersComponent,
    PresentationComponent,
    ModalComponent,
    NoResultsFoundComponent,
    CardComponent,
    ModalXlComponent,
    MapListComponent,
    TabMenuComponent,
    TableSearchComponent,
    MessageModule,
    DropdownModule,
    ConfirmDialogModule,
    MultiSelectModule,
    FileUploadModule,
    TreeTableModule,
    ChipsModule,
    DynamicDialogModule,
    DialogModule,
    TabViewModule,
    ViewOfferDetailsComponent,
    TooltipModule,
    RadioButtonModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ToggleTableDirective,
    ToggleColumnDirective,
    StepperComponent,
    StepperOfferComponent,
    CheckboxGroupComponent,
    ControlComponent,
    DownloadFileComponent,
    ErrorValidationComponent,
    FileUploadComponent,
    LabelInfoComponent,
    PriceModelComponent,
    RadioGroupComponent,
    SelectInputComponent,
    DateFormatPipe,
    CheckboxComponent,
    // TabProductsComponent,
    OfferCampaignsComponent,
    OfferNotificationsComponent,
    OfferLoyaltyComponent,
    BaseTableComponent,
    PageTitleComponent,
    FormBuilderComponent,
    OfferTributesEditComponent,
    OfferLoyaltyEditComponent,
    CampaignDetailsComponentEdit,
    OfferLoyaltyAddComponent,
    OfferChargeCodesComponent,
    OfferSkuAddComponent
  ],
})
export class SharedModule {}
